<svg xmlns="http://www.w3.org/2000/svg" width="92" height="88" viewBox="0 0 92 88">
    <rect fill="#FFF" stroke="#D9DDDF" stroke-width="2" x="1" y="1" width="90" height="86"/>
    <line stroke="#0069C4" stroke-width="2.5" x1="21" y1="44" x2="71" y2="44"/>
    <circle stroke="#000" cx="46" cy="40" r="3" stroke-width="2" fill="none"/>
    <line stroke="#000" x1="46" x2="46" y1="36" y2="15" stroke-width="2"/>
</svg>
